import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:3000', // DEV
  baseURL: 'https://peca-aqui-api-qljdd.ondigitalocean.app/', // DEV
});

export default api;
